import { CloseWhiteIcon, WarningWhiteIcon } from 'components/icons';
import classNames from 'classnames';
import React, { memo, PropsWithChildren } from 'react';
import styles from './Notification.module.scss';
import Text from '../Typography/Text';

export type NotificationProps = {
  onClose?: () => void;
  text?: string;
  type: 'error' | 'success';
};

export default memo(function Notification({
  onClose,
  text,
  type,
}: PropsWithChildren<NotificationProps>) {
  return (
    <div className={classNames(styles.notification, styles[`${type}`])}>
      {type === 'error' && (
        <span className={styles['warning-icon']}>
          <WarningWhiteIcon />
        </span>
      )}
      {!!text && (
        <Text
          className={styles.text}
          suppressDefaultStyles
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
      <span className={styles['close-icon']}>
        <button className={styles['close-icon']} onClick={onClose}>
          <CloseWhiteIcon />
        </button>
      </span>
    </div>
  );
});
